import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MapControl } from "./MapControl";
import { MeasurerControl } from "./MeasurerControl";
import { BaseMapsControl } from "./BaseMapsControl";
export const ToolsControl = props => {
    return (_jsxs(MapControl, { ...props, column: true, children: [_jsx(BaseMapsControl, {}), _jsx(MeasurerControl, {})] }));
};
